module.exports = __webpack_public_path__ + "static/media/share-alt.e1687b64.svg";